import {
  type AppointmentStatus,
  opportunityStatuses,
  type TrackingStatus,
} from '@fv/models'

import type { OppPanelTab } from '../opp-panel/types'

export interface OppListingState {
  activeId?: string
  oppPanelTab?: OppPanelTab
  isOppPanelOpen?: boolean
  status: OppListingStatus
  page: OppPage
  trackingStatus?: TrackingStatus
  appointmentStatus?: AppointmentStatus
}
export interface OppListingActions {
  setOppPanelTab: (oppPanelTab: OppPanelTab) => void
  setActiveId: (activeId: string) => void
  setOppPanelOpen: (isOppPanelOpen: boolean) => void
}

export interface OppListingStore extends OppListingState {
  actions: OppListingActions
}

export const oppListingStatuses = [...opportunityStatuses, 'archived'] as const
export type OppListingStatus = (typeof oppListingStatuses)[number]

export type OppPage =
  | 'open'
  | 'quoting'
  | 'won'
  | 'active'
  | 'search'
  | 'direct'
export const oppPageStatusMap = {
  open: ['open', 'declined'],
  quoting: ['offered', 'lost'],
  won: ['awarded'],
  active: ['confirmed', 'archived'],
} as const
